import { Box, Typography, useTheme } from "@mui/material";
import { useState } from "react";
import Boxoutline from "../../../../../media/images/icons/outline-box";
import CustomButton from "../../../../components/CustomButton";
import { blueGrey } from "@mui/material/colors";
import { ITenderOffer } from "..";
import { convertToJalali } from "../../../../../utils/functions";
import TenderDeatailsModal from "./TenderDeatailsModal";

export default function TenderOfferCard(props: ITenderOffer) {
  const {
    price,
    insertDate,
    id,
    orderId,
    destName,
    goodsName,
    status,
    orderCode,
    srcName,
  } = props;
  const theme = useTheme();

  const [tenderDeatailsModal, setTenderDeatailsModal] = useState(false);

  return (
    <>
      <TenderDeatailsModal
        open={tenderDeatailsModal}
        setOpen={() => setTenderDeatailsModal(false)}
        orderId={orderId}
        id={id}
        status={status}
        price={price}
      />
      <Box
        sx={{
          boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.10)",
          display: "flex",
          border: "1px solid",
          borderColor: blueGrey[100],
          gap: "8px",
          borderRadius: "10px",
          flexDirection: "column",
          padding: "8px",
          backgroundColor: "bgColor.white",
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: "4px",
          }}
        >
          <Box
            sx={{
              backgroundColor: "info.light",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "6px",
              borderRadius: "8px",
            }}
          >
            <Boxoutline color={theme.palette.textColor.main} />
          </Box>

          <Box
            sx={{
              flex: "1",
              display: "flex",
              flexDirection: "column",
              gap: "4px",
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "700",
                }}
              >
                شماره سفارش:
              </Typography>

              <Typography noWrap variant="body2">
                {orderCode}
              </Typography>
            </Box>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "700",
                }}
              >
                تاریخ سفارش:
              </Typography>

              <Typography noWrap variant="body2">
                {convertToJalali(insertDate)}
              </Typography>
            </Box>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "700",
                }}
              >
                نام محموله:
              </Typography>

              <Typography noWrap variant="body2">
                {goodsName}
              </Typography>
            </Box>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "700",
                }}
              >
                مبدا:
              </Typography>

              <Typography noWrap variant="body2">
                {srcName}
              </Typography>
            </Box>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "700",
                }}
              >
                مقصد:
              </Typography>

              <Typography noWrap variant="body2">
                {destName}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: "8px",
          }}
        >
          <CustomButton
            flex={1}
            // loading
            onClick={() => setTenderDeatailsModal(true)}
            title="مشاهده"
            justifyContent="center"
            bgColor="primary.main"
            textColor="#fff"
            px="10px"
            py="12px"
            borderRadius="6px"
            // icon2={<ArrowTickLeft size={16} color={"#fff"} />}
          />
        </Box>
      </Box>
    </>
  );
}
